/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Signals_Ai_Stage_OperateInputs */

const en_directory_hubs_signals_ai_stage_operate = /** @type {(inputs: Directory_Hubs_Signals_Ai_Stage_OperateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Machine interfaces: HTTP API, non-interactive CLI, SDK, MCP server, webhooks, and machine-friendly authentication. 7 checks.`)
};

const zh_directory_hubs_signals_ai_stage_operate = /** @type {(inputs: Directory_Hubs_Signals_Ai_Stage_OperateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`机器接口：HTTP API、非交互 CLI、SDK、MCP 服务器、webhooks 与机器友好的认证。7 项检查。`)
};

/**
* | output |
* | --- |
* | "Machine interfaces: HTTP API, non-interactive CLI, SDK, MCP server, webhooks, and machine-friendly authentication. 7 checks." |
*
* @param {Directory_Hubs_Signals_Ai_Stage_OperateInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_signals_ai_stage_operate = /** @type {((inputs?: Directory_Hubs_Signals_Ai_Stage_OperateInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Signals_Ai_Stage_OperateInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_signals_ai_stage_operate(inputs)
	return zh_directory_hubs_signals_ai_stage_operate(inputs)
});
export { directory_hubs_signals_ai_stage_operate as "directory.hubs.signals.ai.stage.operate" }